import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Tooltip} from 'primeng/tooltip';
import {TranslateService} from '@ngx-translate/core';
import {NgClass} from '@angular/common';
import {Menu} from 'primeng/menu';
import {FindingSeverity} from '@webmate-web-core/shared/types/testmgmt';
import {take} from 'rxjs/operators';
import {FaIconComponent, IconDefinition} from '@fortawesome/angular-fontawesome';
import {MenuItem, PrimeTemplate} from 'primeng/api';
import {faCheckCircle, faDotCircle, faExclamationCircle, faInfoCircle, faTimesCircle} from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'wm-finding-severity-indicator',
    standalone: true,
    imports: [
        Tooltip,
        NgClass,
        Menu,
        FaIconComponent,
        PrimeTemplate
    ],
    templateUrl: './finding-severity-indicator.component.html',
    styleUrl: './finding-severity-indicator.component.less'
})
export class FindingSeverityIndicatorComponent {

    @ViewChild('menu') menu: Menu;

    @Input() severity: FindingSeverity;

    @Input() allowModification: boolean = false;

    // TODO: more form factors
    @Input() formFactor: 'stripe' | 'pill' = 'stripe';

    @Output() severityChange: EventEmitter<FindingSeverity> = new EventEmitter<FindingSeverity>();

    severityName: string;
    icon: IconDefinition;

    menuItems: MenuItem[] = [
        { label: 'None', value: 'not_set', faIcon: faDotCircle, command: () => this.changeSeverity('not_set') },
        { label: 'Error', value: 'error', faIcon: faTimesCircle, command: () => this.changeSeverity('error') },
        { label: 'Warn', value: 'warn', faIcon: faExclamationCircle, command: () => this.changeSeverity('warn') },
        { label: 'Info', value: 'info', faIcon: faInfoCircle, command: () => this.changeSeverity('info') },
        { label: 'Good', value: 'good', faIcon: faCheckCircle, command: () => this.changeSeverity('good') }
    ];

    constructor() {
    }

    update() {
        const severityItem = this.menuItems.find(item => item.value === this.severity);
        this.icon = severityItem?.faIcon;
        this.severityName = severityItem?.label;
    }

    changeSeverity(newSeverity: FindingSeverity) {
        this.severity = newSeverity;
        this.update();
        this.severityChange.emit(this.severity);
    }

    toggleMenu(event: MouseEvent) {
        if (!this.allowModification) {
            return;
        }
        if (this.menu) {
            this.menu.toggle(event);
        }

        event.stopPropagation();
        event.preventDefault();
    }

    ngOnChanges() {
        this.update();
    }


}
